import {DefaultTheme, FlattenInterpolation, ThemeProps} from 'styled-components';

import {SimpleSpinnerLoaderVariant} from '~/shared/components/Loaders/SimpleSpinnerLoader';

import {PieButtonVariant} from './types';
import {
  pieButtonBrandLargeStyles,
  pieButtonBrandMediumStyles,
  pieButtonBrandSmallStyles,
  pieButtonGhostLargeStyles,
  pieButtonGhostMediumStyles,
  pieButtonGhostSmallStyles,
  pieButtonOutlineLargeStyles,
  pieButtonOutlineMediumStyles,
  pieButtonOutlineSmallStyles,
  pieButtonPrimaryLargeStyles,
  pieButtonPrimaryMediumStyles,
  pieButtonPrimarySmallStyles,
  pieButtonPrimaryXLStyles,
  pieButtonSecondaryLargeStyles,
  pieButtonSecondaryMediumStyles,
  pieButtonSecondarySmallStyles,
  pieButtonSecondaryXLStyles,
} from './pieButtonStyles';

export const pieButtonStylesMap: Record<
  PieButtonVariant,
  FlattenInterpolation<ThemeProps<DefaultTheme> & {isLoading: boolean; disabled: boolean}>
> = {
  primarySmall: pieButtonPrimarySmallStyles,
  primaryMedium: pieButtonPrimaryMediumStyles,
  primaryLarge: pieButtonPrimaryLargeStyles,
  primaryXL: pieButtonPrimaryXLStyles,
  brandSmall: pieButtonBrandSmallStyles,
  brandMedium: pieButtonBrandMediumStyles,
  brandLarge: pieButtonBrandLargeStyles,
  secondarySmall: pieButtonSecondarySmallStyles,
  secondaryMedium: pieButtonSecondaryMediumStyles,
  secondaryLarge: pieButtonSecondaryLargeStyles,
  secondaryXL: pieButtonSecondaryXLStyles,
  outlineSmall: pieButtonOutlineSmallStyles,
  outlineMedium: pieButtonOutlineMediumStyles,
  outlineLarge: pieButtonOutlineLargeStyles,
  ghostSmall: pieButtonGhostSmallStyles,
  ghostMedium: pieButtonGhostMediumStyles,
  ghostLarge: pieButtonGhostLargeStyles,
};

export const pieButtonLoaderColorMap: Record<PieButtonVariant, SimpleSpinnerLoaderVariant> = {
  primarySmall: 'whiteSmall',
  primaryMedium: 'whiteSmall',
  primaryLarge: 'whiteLarge',
  primaryXL: 'whiteLarge',
  brandSmall: 'whiteSmall',
  brandMedium: 'whiteSmall',
  brandLarge: 'whiteLarge',
  secondarySmall: 'blackSmall',
  secondaryMedium: 'blackSmall',
  secondaryLarge: 'blackLarge',
  secondaryXL: 'blackLarge',
  outlineSmall: 'blackSmall',
  outlineMedium: 'blackSmall',
  outlineLarge: 'blackLarge',
  ghostSmall: 'blackSmall',
  ghostMedium: 'blackSmall',
  ghostLarge: 'blackLarge',
};
